import { render } from "./CrmNewsCard.vue?vue&type=template&id=bfac0c26&scoped=true"
import script from "./CrmNewsCard.vue?vue&type=script&lang=js"
export * from "./CrmNewsCard.vue?vue&type=script&lang=js"

import "./CrmNewsCard.vue?vue&type=style&index=0&id=bfac0c26&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfac0c26"]])

export default __exports__